// useLogNodeView.js
import { useEffect } from 'react';

// Context
import { useUser } from 'context/UserContext';

// Utilities
import { logNodeView } from 'utilities/NodeAnalytics';

/**
 * Logs views for the current node and its child nodes when the 
 * node key changes.
 */
const useLogNodeView = (node, childNodes) => {

  // User Context
  const {
    user,
  } = useUser();

  useEffect(() => {
    if (!node?.key) return;

    // Log view for parent
    logNodeView(node.key, user);

    // Log views for child nodes
    if (childNodes && Array.isArray(childNodes)) {
      childNodes.forEach(child => {
        if (child?.key) {
          logNodeView(child.key, user);
        }
      });
    }
  }, [user, node?.key, childNodes]);

};

export default useLogNodeView;
